module.exports = __webpack_public_path__ + "assets/inertiajs.cb778d0f.svg";